import React, { useCallback, useState } from 'react';
import { PlusCircle, XCircle } from 'react-bootstrap-icons'

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';

import SimulationServiceTypeSelect from '../Simulation/SimulationServiceTypeSelect';
import CountrySelect from '../../dialogs/CountrySelect';

export default function InternationalQuote({ handleAPIRequest }) {
    
    const [alertError, setAlertError] = useState(null)
    const [alertSuccess, setAlertSuccess] = useState(null)
    
    const [internationalQuoteInput, setInternationalQuoteInput] = useState({
        serviceType: null,
        serviceTypeCategory: null,
        adultPediatric: 'A',
        countries: []
    });

    const setAdultPediatric = (adultPediatric, serviceType) => {
        if (adultPediatric && serviceType) {
            setInternationalQuoteInput({
                adultPediatric
            ,   serviceTypeCategory: internationalQuoteInput.serviceTypeCategory
            ,   serviceType
            ,   countries: []
            });
        }
        else if (adultPediatric) {
            setInternationalQuoteInput({
                adultPediatric
            ,   serviceTypeCategory: internationalQuoteInput.serviceTypeCategory
            ,   serviceType: internationalQuoteInput.serviceType
            ,   countries: []
            });
        }
        else {
            setInternationalQuoteInput({
                adultPediatric: 'A'
            ,   serviceTypeCategory: internationalQuoteInput.serviceTypeCategory
            ,   serviceType: internationalQuoteInput.serviceType
            ,   countries: []
            });
        }
    };

    const setServiceTypeCategory = (serviceTypeCategory) => {
        if (serviceTypeCategory) {
            setInternationalQuoteInput({
                adultPediatric: internationalQuoteInput.adultPediatric
            ,   serviceTypeCategory
            ,   serviceType: null
            ,   countries: []
            });
        }
        else {
            setInternationalQuoteInput({
                adultPediatric: internationalQuoteInput.adultPediatric
            ,   serviceTypeCategory: null
            ,   serviceType: null
            ,   countries: []
            });
        }
    };

    const setServiceType = (serviceType) => {
        if (serviceType) {
            setInternationalQuoteInput({
                adultPediatric: internationalQuoteInput.adultPediatric
            ,   serviceTypeCategory: internationalQuoteInput.serviceTypeCategory
            ,   serviceType 
            ,   countries: []
            });
        }
        else {
            setInternationalQuoteInput({
                adultPediatric: internationalQuoteInput.adultPediatric
            ,   serviceTypeCategory: internationalQuoteInput.serviceTypeCategory
            ,   serviceType: null
            ,   countries: []
            });
        }
    };

    const onSelectCountries = (countries) => {
        const newCountries = [...internationalQuoteInput.countries];
        countries.forEach((country) => {
            newCountries.push(country);
        });

        setInternationalQuoteInput((prev) => ({
            ...prev,
            countries: newCountries
        }));
    };
    
    const onCountryDelete = (country) => {

        const newCountries = internationalQuoteInput.countries.filter((c) => {
            return c.international_quote_id !== country.international_quote_id;
        });

        setInternationalQuoteInput((prev) => ({
            ...prev,
            countries: newCountries
        }));
    };

    // ************************************************************************
    // Modals CountrySelect

    const [modal_CountrySelect_dialog_open, setCountrySelectDialogOpen] = useState(false)

    const onModalCountrySelectDialogOpen = () => {
        setCountrySelectDialogOpen(true);
    }

    // ************************************************************************
    // Submit International Quote

    const onSubmitInternationalQuote = useCallback(() => {
        console.log("International Quote Data:", {
            serviceTypeCategory: internationalQuoteInput.serviceTypeCategory,
            serviceType: internationalQuoteInput.serviceType,
            countries: internationalQuoteInput.countries
        });

        const do_post = async () => {
            const res = await handleAPIRequest('/api/v1/send_email', {
                method: 'POST' 
            ,   body: JSON.stringify({
                    to: 'support@healthrate.io',
                    subject: 'International Quote',
                    body: `Service Type Category: ${ 
                        internationalQuoteInput.serviceTypeCategory?.service_type_category || 'None'
                    }\nService Type: ${
                        internationalQuoteInput.serviceType?.service_type || 'None'
                    }\nCountries: ${internationalQuoteInput.countries.map(country => country.country).join(', ') || 'None'}`,
                })
            });
            
            if (res.status === 200) {
                setAlertSuccess({
                    title: 'International Quote Submitted'
                ,   body: 'Your request has been submitted successfully.'
                });
                setTimeout(() => {setAlertSuccess(null)}, 7000);
                console.log('International Quote submitted successfully'); 
            } 
            else { 
                setAlertError({
                    title: 'Error Submitting International Quote: ',
                    body: res.statusText
                });
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Error submitting International Quote', res.statusText);
            }
        }

        do_post();

    }, [handleAPIRequest, internationalQuoteInput]);


    return (
        <>
        <Alert show={!!alertError} variant="danger">
            <Alert.Heading>{alertError ? alertError.title : ''}</Alert.Heading>
            <p dangerouslySetInnerHTML={alertError ? { __html: alertError.body } : { __html: '' }}></p>
        </Alert>

        <Alert show={!!alertSuccess} variant="success">
            <Alert.Heading>{alertSuccess ? alertSuccess.title : ''}</Alert.Heading>
            <p dangerouslySetInnerHTML={alertSuccess ? { __html: alertSuccess.body } : { __html: '' }}></p>
        </Alert>

        <CountrySelect
            show={ modal_CountrySelect_dialog_open }
            onHide={ () => setCountrySelectDialogOpen(false) }
                size="xl"
            handleAPIRequest={ handleAPIRequest }
            selected_countries={ internationalQuoteInput.countries }
            onSelectCountries={ onSelectCountries }
        />
        
        <div className="bg-light mt-4 mb-4 p-3">
            <Row>
                <h1>International Quote</h1>
            </Row>
            <Row className="mt-3">
                <p>HealthRate has established relationships with several prestigious medical centers worldwide and may be able to secure <strong>fixed-price bids</strong> for your case(s). By choosing this option, you could save between <strong>40-60% compared to U.S.-based medical centers</strong>.</p>
                <p>Please complete the form below, and one of our experts will promptly contact you to explain the process and gather additional details about your case(s).</p>
            </Row>
        </div>

        <div className='bg-light mt-4 mb-4 p-3'>
            <Row>
                <h2>Service Type</h2>
            </Row>

            <Row>
                <SimulationServiceTypeSelect
                    element_id="serviceType"
                    handleAPIRequest={ handleAPIRequest }
                    simulationInput={ internationalQuoteInput }
                    setAdultPediatric={ setAdultPediatric }
                    setServiceTypeCategory={ setServiceTypeCategory }
                    setServiceType={ setServiceType }
                />
            </Row>
        </div>

        <div className='bg-light mt-4 mb-4 p-3'>
            <Row>
                <h2>Countries</h2>
            </Row>
            
            {internationalQuoteInput.countries.map((c) => (
                <Row 
                    className="m-3"
                    key={ `international_quote_${c.international_quote_id}` }
                >
                    <h5><Button id={`country_remove_${c.international_quote_id}`} onClick={() => onCountryDelete(c)} variant="outline-danger" ><XCircle /></Button> { c['country'] }</h5>
                </Row>
            ))}

            <div className="row border-top pt-4">
                <div className="col-md-6 mb-sm-2 mb-2">
                    <Button id="add_country" onClick={ onModalCountrySelectDialogOpen } >
                        <PlusCircle /> Add Countries
                    </Button>
                </div>
            </div>
        </div>

        <div className='bg-light mt-4 mb-4 p-3'>
            <div className="row">
                <div className="col-md-12">
                    <Button id="international_quote_submit"
                        onClick={ onSubmitInternationalQuote }
                        className="btn btn-primary"
                        style={{ width: '100px' }}
                        disabled={
                            !internationalQuoteInput.serviceTypeCategory ||
                            !internationalQuoteInput.serviceType ||
                            internationalQuoteInput.countries.length === 0  
                        }
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </div>
    </>
    );
}
